import React from "react";
import { connect } from "react-redux";

import GroheMobileFeatureTop from "./groheMobileFeatureTop";
import GroheFeatureContentInCart from "../../groheNavigation/groheFeature/groheFeatureContentInCart";

const GroheMobileFeatureAddedToTheCart = (props) => {

  const {lookActiveFeature} = props;

  if (!lookActiveFeature) {
    return null
  }

  return (
    <div className={"gm-feature"}>
      <GroheMobileFeatureTop/>
      <GroheFeatureContentInCart/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened, lookActiveFeature} = store.lookState;
  return {
    lookOpened,
    lookActiveFeature
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(GroheMobileFeatureAddedToTheCart)
